(() => {
  if (window.NazoruProductLP) return;
  window.NazoruProductLP = true;

  const init = (scope = document) => {
    scope.querySelectorAll('[data-nazoru-lp]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const revealItems = root.querySelectorAll('[data-reveal]');
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12 });
        revealItems.forEach((item) => observer.observe(item));
      } else {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      }

      root.querySelectorAll('[data-nazoru-variant]').forEach((select) => {
        select.addEventListener('change', () => {
          const option = select.options[select.selectedIndex];
          root.querySelectorAll('[data-nazoru-main-id]').forEach((input) => { input.value = select.value; });
          root.querySelectorAll('[data-nazoru-main-price]').forEach((price) => { price.textContent = option.dataset.price || ''; });
        });
      });

      root.querySelectorAll('[data-nazoru-compare]').forEach((compare) => {
        const range = compare.querySelector('input[type="range"]');
        const before = compare.querySelector('[data-before]');
        const handle = compare.querySelector('[data-handle]');
        if (!range || !before || !handle) return;
        range.addEventListener('input', () => {
          before.style.width = `${range.value}%`;
          handle.style.left = `${range.value}%`;
        });
      });

      root.querySelectorAll('[data-nz-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('[data-nz-carousel-track]');
        const slides = Array.from(carousel.querySelectorAll('[data-nz-slide]'));
        const dots = Array.from(carousel.querySelectorAll('[data-nz-dot]'));
        if (!track || slides.length !== 3 || dots.length !== 3) return;

        const setActive = (index) => {
          dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
        };

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
            setActive(index);
          });
        });

        let ticking = false;
        track.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(() => {
            const center = track.scrollLeft + track.clientWidth / 2;
            let activeIndex = 0;
            let nearest = Infinity;
            slides.forEach((slide, index) => {
              const distance = Math.abs(center - (slide.offsetLeft + slide.offsetWidth / 2));
              if (distance < nearest) { nearest = distance; activeIndex = index; }
            });
            setActive(activeIndex);
            ticking = false;
          });
        }, { passive: true });
      });

    });
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
